import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        // Clear hash and go to dashboard or POS based on role
        window.history.replaceState(null, "", window.location.pathname);
        const dest = res.data.role === "admin" ? "/dashboard" : "/pos";
        navigate(dest, { state: { user: res.data } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand">
      <div className="font-heading text-xl text-ink">Signing you in…</div>
    </div>
  );
}
